import { Injectable } from '@angular/core';

@Injectable()

export class AppService {

  constructor(){}

  handleUser(dataUser: string){
    sessionStorage.setItem('user', JSON.stringify(dataUser));
  }

  handleDroits(dataDroits: string){
    sessionStorage.setItem('droits', JSON.stringify(dataDroits));
   }

  getDataUser(){
    return JSON.parse(sessionStorage.getItem('user')!);
  }

  getDroits(){
    return JSON.parse(sessionStorage.getItem('droits')!);
  }

  removeDataUser() {
    sessionStorage.removeItem('user');
  }

  removeDataUserDroits() {
    sessionStorage.removeItem('droits');
  }



}
